import { schema } from 'normalizr';

const paginationWebinarsSchema = new schema.Entity('pagination', {}, {
  idAttribute: () => 'webinars'
});

export { paginationWebinarsSchema };
